"use client";

import { ModalContainer } from "@kyan/ui";

import { useSharePnlCardsModal } from "#/store/app/sharePnlCardModal/sharePnlCardsModal";
import { type PnlCardProps } from "#/types/pnlCard";

import { SharePnLModalContent } from "./components/SharePnLModalContent";

export const SharePnLCardModal: React.FC<PnlCardProps> = () => {
  const { isOpen, modalData, close } = useSharePnlCardsModal();

  if (!modalData) return null;

  return (
    <ModalContainer open={isOpen} onOpenChange={close}>
      <SharePnLModalContent {...modalData} />
    </ModalContainer>
  );
};
